import { useContext } from 'react';
import { listNodesContext } from '../context/listNodesContext';

export const useListNodes = () => {
  const listNodesData = useContext(listNodesContext);

  return listNodesData;
};
